export enum Colour {
    BLACK,
    BLUE,
    ORANGE,
    RED,
}

export enum TileType {
    JOKER,
    ONE,
    TWO,
    THREE,
    FOUR,
    FIVE,
    SIX,
    SEVEN,
    EIGHT,
    NINE,
    TEN,
    ELEVEN,
    TWELVE,
    THIRTEEN,
}

export type Tile = {
    Colour: Colour;
    TileType: TileType;
};

export type GridStackTile = {
    x: number;
    y: number;
    colour: Colour;
    tileType: TileType;
    staging: boolean;
};
